document.addEventListener('DOMContentLoaded', function() {
  var popup = document.getElementById('mp2');
  if (!popup) return;

  // Open
  document.querySelectorAll('.popout__toggle').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      popup.classList.add('visible');
    });
  });

  // Close
  document.querySelectorAll('.close_mp2, .close_mp2_button').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      popup.classList.remove('visible');
    });
  });

  // Close on overlay click
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      popup.classList.remove('visible');
    }
  });
});

// Localization Form
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.disclosure__button') || this.querySelector('.popout__toggle');
    this.panel = this.querySelector('.disclosure__list');
    this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');

    if (this.button) {
      this.button.addEventListener('click', this.toggle.bind(this));
      this.button.addEventListener('focusout', this.close.bind(this));
    }
    this.addEventListener('keyup', function(e) { if (e.code === 'Escape') this.close(); }.bind(this));
    this.querySelectorAll('a').forEach(function(link) { link.addEventListener('click', this.select.bind(this)); }.bind(this));
  }

  toggle() {
    var expanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', !expanded);
    this.panel.toggleAttribute('hidden');
  }

  close(e) {
    if (e && e.relatedTarget && this.contains(e.relatedTarget)) return;
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('hidden', '');
  }

  select(e) {
    e.preventDefault();
    this.input.value = e.currentTarget.dataset.value;
    this.querySelector('form').submit();
  }
}

customElements.define('localization-form', LocalizationForm);
